module.exports = __webpack_public_path__ + "static/tooltip1_6-c8deb85bbb82de84a655c5f9a8c09d05.png";